import React from "react";
import InspectionType from "../../scenes/requirements/InspectionType";
import InspectionDetails from "../../scenes/requirements/InspectionDetails";

const RequirementsTabContent = ({
  menuInspections,
  getSelectedInspection,
  displayInspectionID,
  currentTabIndex,
}) => {
  return (
    <>
      <div className="flex flex-col gap-2 items-center">
        <div className="w-full">
          <InspectionType
            inspections={menuInspections}
            getSelectedInspection={getSelectedInspection}
          />
        </div>
      </div>
      <div>
        <InspectionDetails
          inspectionID={displayInspectionID}
          currentIndexTab={currentTabIndex}
        />
      </div>
    </>
  );
};

export default RequirementsTabContent;
